import {BiotwinSettings} from './types';

export const defaultBiotwinSettings: BiotwinSettings = {
  duplicativePhrasesVisible: false,
  hiddenPhrasesVisible: false,
  optionalModulesVisible: false,
  policyAndStandardPhrasesVisible: false,
};
